import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import * as _ from 'lodash';

@Component({
  templateUrl: './selector.component.html',
  standalone: false
})
export class SelectorComponent implements OnInit {
  // use cases :
  // - selectorValues is an array of objects containing a 'value' property,
  // then, selectedIndex is the value of the selected item.
  // -  selectorValues is an array of anything else, then selectedIndex is the index
  public selectorValues: any[];
  public selectedIndex: number | string = -1;
  public query = '';
  public search = false;
  public searchFromStart = false;
  public none = false;
  public showAsIcons = false;

  constructor(public modal: ModalComponent, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  selectMenu(indexOrValue: number | string | null): void {
    this.cdRef.detectChanges();
    if (indexOrValue === null) {
      this.modal.close({ value: null, selectedIndex: null });
      return;
    }
    let selectedObject =
      this.selectorValues.find((el) => this.hasProperty(el, 'value') && (el as any).value === indexOrValue) ||
      this.selectorValues[indexOrValue];
    // Return value of the modal {value, selectedIndex} :
    // If selectorValues is an array of objects with a 'value' property,
    // value will be the selected object and selectedIndex will be the value.
    // If selectorValues is an array of anything else, selectedIndex will be the index of the selected object,
    // and selectedObject will be the object itself.
    this.modal.close({ value: selectedObject, selectedIndex: indexOrValue });
  }

  public init(data: any) {
    this.selectorValues = data.values;
    this.selectedIndex = data.selectedIndex;
    this.search = data.search;
    this.searchFromStart = data.searchFromStart;
    this.none = data.none;
    this.showAsIcons = data.showAsIcons;
    this.processData();
  }

  public getData(): any {
    return null;
  }

  public hasProperty(item: any, property: string) {
    return item.hasOwnProperty(property);
  }

  processData() {
    _.forEach(this.selectorValues, (el) => {
      if (!el.search) {
        if (this.searchFromStart) {
          el.search = (query: string): boolean =>
            (el.label && el.label.toLowerCase().startsWith(query.toLowerCase())) ||
            (el.hasOwnProperty('toLowerCase') && el.toLowerCase().startsWith(query.toLowerCase()));
        } else {
          el.search = (query: string): boolean =>
            (el.label && el.label.toLowerCase().includes(query.toLowerCase())) ||
            (el.hasOwnProperty('toLowerCase') && el.toLowerCase().includes(query.toLowerCase()));
        }
      }
    });
  }
}
